import { Box } from '@mui/material';
import { FC, useCallback, useEffect, useState } from 'react';
// component
import ProfileForm from './ProfileForm';
// constants, schema, style
import { HTTP_STATUS } from 'constants/index';
import { UserPayload, useFetchUserSettingLazyQuery } from 'generated/graphql';

const Profile: FC = () => {
  const [user, setUser] = useState<UserPayload['user']>(null);

  const [getUser, { loading }] = useFetchUserSettingLazyQuery({
    onCompleted: (data) => {
      const { fetchUser } = data;
      const { response, user } = fetchUser;

      const { status } = response || {};
      if (status === HTTP_STATUS.SUCCESS) {
        setUser(user as UserPayload['user']);
      }
    },
    onError: () => {
      setUser(null);
    },
  });

  const fetchUser = useCallback(async () => {
    await getUser();
  }, [getUser]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <Box mt={5}>
      <ProfileForm user={user} loading={loading} />
    </Box>
  );
};

export default Profile;
